module.exports = __webpack_public_path__ + "img/union.678b9531.svg";